import { render, staticRenderFns } from "./CartPromo.vue?vue&type=template&id=84ac2458&scoped=true&"
import script from "./CartPromo.vue?vue&type=script&lang=js&"
export * from "./CartPromo.vue?vue&type=script&lang=js&"
import style0 from "./CartPromo.vue?vue&type=style&index=0&id=84ac2458&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ac2458",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconPromoCode: require('/opt/build/repo/components/icons/IconPromoCode.vue').default})
